import(/* webpackMode: "eager" */ "/codebuild/output/src270031596/src/github.com/bitstone/offerz-nextjs/src/app/global-error.tsx");
